"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _checkout = _interopRequireDefault(require("../../checkout"));
var _home = _interopRequireDefault(require("./home"));
var _enter = _interopRequireDefault(require("./enter"));
var _finance = _interopRequireDefault(require("./finance"));
var _manageEntries = _interopRequireDefault(require("./manage-entries"));
var _setUp = _interopRequireDefault(require("./set-up"));
var _startList = _interopRequireDefault(require("./start-list"));
var _notFound = _interopRequireDefault(require("../../not-found"));
var _loginForm = _interopRequireDefault(require("../../core/login-form"));
var _loginConnector = _interopRequireDefault(require("../../../login/login-connector"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
// Use of a styled h1 used to improve printing of start list (other pages are currently not printed)
const H1 = _styledComponents.default.h1`
  @media print {
    font-size: 1.3em;
    line-height: 1.4em;
    margin-top: 0em;
    margin-bottom: 0em;
  }
`;
var _ref = /*#__PURE__*/_react.default.createElement(_notFound.default, null);
var _ref2 = /*#__PURE__*/_react.default.createElement(_loginForm.default, null);
var _ref3 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function Competitions({
  match,
  loaded,
  competition,
  isAuthenticated
}) {
  if (loaded && !competition) {
    if (isAuthenticated) {
      return _ref;
    } else {
      return _ref2;
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(H1, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "pull-xs-right"
  }, match.params.yearID), loaded ? competition.competitionName : 'Loading...'), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    from: match.path + '/finance',
    to: match.url + '/finance/summary',
    exact: true
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    from: match.path + '/manage-entries',
    to: match.url + '/manage-entries/summary',
    exact: true
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    from: match.path + '/set-up',
    to: match.url + '/set-up/competition',
    exact: true
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: match.path,
    component: _home.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: match.path + '/enter',
    component: _enter.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: match.path + '/finance',
    component: _finance.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: match.path + '/manage-entries',
    component: _manageEntries.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: match.path + '/set-up',
    component: _setUp.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: match.path + '/start-list',
    component: _startList.default
  }), _ref3));
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref4 = {
  competitionName: true
};
var _default = exports.default = (0, _reactBicycle.connect)((0, _loginConnector.default)(Competitions), props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref4
}), undefined, {
  renderLoading: true
});